export const PrinterConst = {
    timeout : 180000, //  3 minutes
    duration : 10000, // 10 seconds
    maxValue: 30000000 // approx 8 hours
}